import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { SelectTipoHabilitacion, FiltroTipoHabilitacion } from "./TiposHabilitacion";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

const CAMPOS_ORDEN = [
  ["tipo", "Tipo"],
  ["marca", "Marca"],
  ["color", "Color"],
  ["proveedor", "Proveedor"],
  ["alias", "Alias (como lo conocen)"],
];

function ListadoHabilitacion() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const [habilitacion, setHabilitacion] = useState([]);
 

  const [idEditHabilitacion, setIdEditHabilitacion] = useState("");
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [unidad, setUnidad] = useState("");
  const [selectedUnidad, setSelectedUnidad] = useState("");
  const [selectedUnidadEdit, setSelectedUnidadEdit] = useState("");
  const [costo, setCosto] = useState("");
  // Columnas de la Orden de Produccion (PDF de la orden de maquila).
  const [datosOrden, setDatosOrden] = useState({ tipo: "", marca: "", color: "", proveedor: "", alias: "" });

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [activo, setActivo] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");

  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const [fotoNueva, setFotoNueva] = useState(null);
  const [subiendoFoto, setSubiendoFoto] = useState(false);
  const [nombreFoto, setNombreFoto] = useState("");
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allHabilitacion = response.data;
        // Array para pagination
        let arrayTabla = allHabilitacion
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              activo: a.is_active,
              nombre: a.nombre,
              costo: a.costo,
              unidad: a.unidad,
              observaciones: a.observaciones,
              tipo: a.tipo || "",
              marca: a.marca || "",
              color: a.color || "",
              proveedor: a.proveedor || "",
              alias: a.alias || "",
              descripcion:a.descripcion,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setHabilitacion(allHabilitacion);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
   
  }, []);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (!filtroTipo || a.tipo === filtroTipo) &&
        (activo == 0 ||
        activo == a.is_active)
      ) {
        return [
          a.nombre,
          "$" + new Intl.NumberFormat("en-US").format(a.costo),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Habilitacion`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Nombre",
          "Costo",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Habilitacion.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if ((!filtroTipo || a.tipo === filtroTipo) && (activo == 0 || activo == a.is_active)) {
        return {
          Id: a._id,
          Nombre: a.nombre,
          Descripcion: a.descripcion,
          Unidad: a.unidad,
          Costo: a.costo,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoHabilitacion";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoHabilitacion",
        sheetFilter: [
          "Id",
          "Nombre",
          "Descripcion",
          "Unidad",
          "Costo",
        ],
        sheetHeader: [
          "Id",
          "Nombre",
          "Descripcion",
          "Unidad",
          "Costo",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        // (selectedTiposHabilitacionFiltro == 0 || selectedTiposHabilitacionFiltro == a.grupos?.[0]?._id) &&
        activo == 0 ||
        activo == a.is_active
      ) {
        return [
          a.nombre,
          "$" + new Intl.NumberFormat("en-US").format(a.costo),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Habilitacion`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Nombre",
          "Costo",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Habilitacion",
          email: mailTo,
          fileName: "ListadoHabilitacion.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Habilitacion.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaFoto(
    idEdit,
    nombreHabilitacion
  ) {
    setPhoto("")
    setFotoNueva(null);
    setNombreFoto(nombreHabilitacion || "");
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}?carpeta=habilitacion`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));


    setIdEditHabilitacion(idEdit);
    toggleFoto();
  }


  /** Sube (o reemplaza) la foto desde la ventana de la foto, sin pasar por Editar. */
  function subirFoto() {
    if (!fotoNueva) return;
    if (!fotoNueva.type.startsWith("image/")) {
      Swal.fire("Archivo no válido", "Elige una imagen (JPG o PNG)", "warning");
      return;
    }
    setSubiendoFoto(true);
    const formData = new FormData();
    formData.append("habilitacion", idEditHabilitacion);
    formData.append("file", fotoNueva);
    axios
      .post(URL_FILEPOST, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setPhoto(res.data.version);
        setFotoNueva(null);
        axios.post(
          URL_LOGS,
          {
            tipo: "Foto Habilitacion",
            detalle: `${nombreFoto}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Listo", "Foto guardada", "success");
      })
      .catch((error) => {
        Swal.fire(
          "No se pudo subir la foto",
          (error.response && error.response.data && error.response.data.message) || "Intenta de nuevo",
          "error"
        );
      })
      .finally(() => setSubiendoFoto(false));
  }

  function jalaInfo(
    nombre,
    descripcion,
    unidad,
    costo,
    observaciones,
    idEdit,
    orden = {}
  ) {
    setDatosOrden({ tipo: orden.tipo || "", marca: orden.marca || "", color: orden.color || "", proveedor: orden.proveedor || "", alias: orden.alias || "" });
    setNombre(nombre);
    setDescripcion(descripcion);
    setSelectedUnidadEdit(unidad);
    setCosto(costo);
    setObservaciones(observaciones);
    setIdEditHabilitacion(idEdit);
    toggleEdit();
  }

  function editHabilitacion(event) {
    event.preventDefault();
    const URL_HABILITACION_EDIT = `${process.env.REACT_APP_URL_HABILITACION}/${idEditHabilitacion}`;
    if (file == null) {
      axios
        .all([
          axios.patch(
            URL_HABILITACION_EDIT,
            {
              nombre,
              descripcion,
              observaciones,
              ...datosOrden,
              unidad: selectedUnidadEdit,
              costo,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          ),
        ])
        .then(() => {
          axios.post(
            URL_LOGS,
            {
              tipo: "Editar Habilitacion",
              detalle: `${nombre}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          toggleEdit();
          Swal.fire("Good job!", "Actualizado con exito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      axios
        .all([
          axios.patch(
            URL_HABILITACION_EDIT,
            {
              nombre,
              descripcion,
              observaciones,
              ...datosOrden,
              unidad: selectedUnidadEdit,
              costo,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          ),
        ])

        .then(() => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("habilitacion", idEditHabilitacion);

          axios
            .post(URL_FILEPOST, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then(() => {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Habilitacion",
                  detalle: `${nombre}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );

              toggleEdit();
              Swal.fire("Good job!", "Actualizado con exito", "success");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
        });
    }
  }

  const headers = [
    { name: "Activo", field: "activo", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Descripcion", field: "descripcion", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Unidad", field: "unidad", sortable: true },
    { name: "Costo", field: "costo", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.descripcion ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.alias ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.tipo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.observaciones ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.unidad ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.costo ?? "").includes(search) 
      );
    }

    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

    if (filtroTipo) {
      computedComments = computedComments.filter((e) => e.tipo === filtroTipo);
    }

    setTotalItems(computedComments.length);

 //Sorting comments
    if (
      sorting.field &&
      sorting.field != "costo" 
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "costo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "costo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }


    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    activo,
    filtroTipo,
  ]);

 

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_habilitacion ? (
        <div className="card container col-8">
          <Row>
            <Col md={8}>
              {user.menu_habilitacion ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/HabilitacionCreate"
                >
                  Nueva Habilitacion
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Habilitacion
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCatalogos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Habilitacion</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-tape" style={{ marginRight: 8, color: "#10b981" }} />
                Habilitacion
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
         

            <Col md={2}>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>Tipo</Label>
              <FiltroTipoHabilitacion
                bsSize="sm"
                value={filtroTipo}
                onChange={(v) => {
                  setFiltroTipo(v);
                  setCurrentPage(1);
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.activo}</td>
                      <td>{a.nombre}</td>
                      <td>{a.descripcion}</td>
                      <td>{a.observaciones}</td>
                      <td>{a.unidad}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costo)}</td>
                      <td>
                        {user.menu_habilitacion ? (
                          <div>
                            <Button
                              color="info"
                              id="Foto"
                              size="sm"
                              title="Foto"
                              onClick={(e) =>
                                jalaFoto(
                                  a._id,
                                  a.nombre
                                )
                              }
                            >
                              <i class="fas fa-camera"></i>
                            </Button>



                            <Button title="Editar"
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.nombre,
                                  a.descripcion,
                                  a.unidad,
                                  a.costo,
                                  a.observaciones,
                                  a._id,
                                  a
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            <Baja
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_HABILITACION}
                            />
                          </div>
                        ) : (
                          <div>
                            <Button title="Editar" color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            <i className="fas fa-edit" style={{ marginRight: 8, color: "#10b981" }} />
            Editar habilitacion {nombre}
          </h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-tape" />
              <span className="form-section-title">Datos de la Habilitacion</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={3}>
              <Label>Nombre</Label>
              <Input
                type="text"
                placeholder="Nombre"
                value={nombre}
                required
                onChange={(e) => {
                  setNombre(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Descripcion</Label>
              <Input
                type="text"
                placeholder="Descripcion"
                value={descripcion}
                required
                onChange={(e) => {
                  setDescripcion(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Costo</Label>
              <Input
                type="number"
                placeholder="Costo"
                value={costo}
                required
                onChange={(e) => {
                  setCosto(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
                <Label>Unidad</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedUnidadEdit}
                  required
                  onChange={(e) => {
                    setSelectedUnidadEdit(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Piezas">Piezas</option>
                  <option value="Metros">Metros</option>
                  <option value="Kilos">Kilos</option>
                </Input>
              </Col>
          </Row>
          <Row>
            {CAMPOS_ORDEN.map(([campo, etiqueta]) => (
              <Col md={3} key={campo}>
                <Label>{etiqueta}</Label>
                {campo === "tipo" ? (
                  <SelectTipoHabilitacion value={datosOrden.tipo} onChange={(v) => setDatosOrden({ ...datosOrden, tipo: v })} />
                ) : (
                  <Input
                    type="text"
                    value={datosOrden[campo] || ""}
                    onChange={(e) => setDatosOrden({ ...datosOrden, [campo]: campo === "alias" ? e.target.value : e.target.value.toUpperCase() })}
                  />
                )}
              </Col>
            ))}
          </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-sticky-note" />
              <span className="form-section-title">Observaciones y Foto</span>
            </div>
            <div className="form-section-body">
          <Row>

            <Col md={3}>
              <Label>
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            <Col md={6}>
              <Label>
                Foto
              </Label>
              <Input
                type="file"
                onChange={(e) => {
                  setFile(e.target.files?.[0]);
                }}
              />
            </Col>
          </Row>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editHabilitacion}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>




      <Modal isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>
            Foto de la Habilitación {nombreFoto}
          </h4>
        </ModalHeader>
        <ModalBody>
          <div style={{ textAlign: "center" }}>
            {photo ? (
              <img
                src={`${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/v${photo}/cavannaMezclillaHabilitacion/${idEditHabilitacion}`}
                alt={nombreFoto}
                style={{ maxWidth: "100%", maxHeight: 400 }}
              />
            ) : (
              <h6>Esta habilitación no tiene foto.</h6>
            )}
          </div>
          {user.menu_habilitacion ? (
            <div className="mt-3">
              <Label>{photo ? "Cambiar foto" : "Agregar foto"}</Label>
              <Input
                type="file"
                accept="image/*"
                onChange={(e) => setFotoNueva(e.target.files?.[0] || null)}
              />
            </div>
          ) : null}
        </ModalBody>
        {user.menu_habilitacion ? (
          <ModalFooter>
            <Button color="success" disabled={!fotoNueva || subiendoFoto} onClick={subirFoto}>
              <i className="fas fa-upload" style={{ marginRight: 6 }} />
              {subiendoFoto ? "Subiendo..." : "Guardar foto"}
            </Button>
          </ModalFooter>
        ) : null}
      </Modal>

      {loader}
    </>
  );
}

export default ListadoHabilitacion;
